module.exports = __webpack_public_path__ + "static/biancoline-baa00377c823d7015e65c48919a5e959.png";